export default "__VITE_ASSET__CsYQcOC3__"